import { Component } from '@angular/core';

@Component({
  selector: 'app-vehicles-realtime-view',
  standalone: false,
  templateUrl: './vehicles-realtime-view.component.html',
  styleUrl: './vehicles-realtime-view.component.css'
})
export class VehiclesRealtimeViewComponent {

}
